<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header class="card-menu">
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">Video Templates</b-link> / {{item ? item.name : ''}}</span>
        <b-button size="sm" class="float-right" :to="{name: `${collection}_edit`, params: {from_item: item}}">Edit</b-button>

        <b-dropdown size='sm' text="Integrate" class="float-right mr-2">
          <template #button-content>
            <i class="fad fa-plug"></i> Integrate
          </template>

          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'hubspot'}}">HubSpot sequence</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'reply'}}">Reply.io</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'prospect.io'}}">Prospect</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'close.io'}}">Close.io</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'persistIQ'}}">PersistIQ</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'salesforce'}}">Salesforce</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'salesloft'}}">SalesLoft</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'outreach.io'}}">Outreach.io</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'mixmax'}}">Mixmax</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'linkedin_automation'}}">LinkedIn</b-dropdown-item>
          <b-dropdown-item :to="{name: `project_integrate`, params: {from_item: item, integration: 'other'}}">Other email</b-dropdown-item>
        </b-dropdown>

        <b-button v-if="profile.role === 'admin'" size="sm" class="float-right mr-2" :href="`https://console.firebase.google.com/u/0/project/${config && config.firebase_config ? config.firebase_config.projectId : 'puppet-dev'}/firestore/data~2Fproject~2F${$route.params.id}`" target="_blank"><i class="fas fa-database"></i></b-button>

        <div class="float-right mr-2" v-if="item && item.pending_count > 0">
          <b-badge variant="transparent" class="btn-padding">
            {{item.pending_count}} video{{item.pending_count > 1 ? 's' : ''}} processing&nbsp;
            <div class="spinner-border" role="status" style="width: 1rem; height: 1rem; font-size: 0.5rem;">
              <span class="sr-only">.</span>
            </div>
          </b-badge>
        </div>
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>
        <b-alert variant="warning" :show="item.status == constants.item_status.error"><strong>An error occured:</strong> {{item.error_message}}</b-alert>
        <b-alert variant="info" :show="item.status == constants.project_status.pending" class='text-center'>
          <span>Video processing</span>
          <LoadingBar seconds="120" :start_date="item.updated" class='mt-2'/>
        </b-alert>
        <b-alert variant="danger" :show="item.status == constants.item_status.deleted"><strong>Deleted:</strong> This project was deleted</b-alert>

        <b-alert variant="info" :show="item.dismiss_tune === false && item.status == constants.project_status.complete">
          <b-row>
            <b-col>
              <h5 class="mt-1">Clone sounding fuzzy or unnatural?</h5>
              <!-- <p>Tune your voice to optimize how it sounds</p> -->
            </b-col>
            <b-col>
              <b-button class='float-right' variant="secondary" size="sm" :to="{name: `${collection}_tune`, params: {from_item: item}}">Tune clone</b-button>
              <b-button variant="link"  class='float-right' size="sm" @click="dismiss_tune">Dismiss</b-button>
            </b-col>
          </b-row>
        </b-alert>

        <ProjectAnalytics :project="item" class='mx-a'/>
      </div>
    </b-card>

    <keep-alive include="project_item_list">
      <router-view :profile="profile" :user="user" :project="item" v-if="item && item.name"/>
    </keep-alive>

  </b-container>
</template>

<script>
/*eslint no-console: ["error", { allow: ["log", "warn", "error"] }] */

import { db } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"
import ProjectAnalytics from "@/components/ProjectAnalytics.vue"

export default {
  metaInfo: {title: 'Video'},
  props: ['profile', 'user'],
  components: {ProjectAnalytics},
  mixins: [ItemMixin],
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id),
    }
  },
  data() {
    return {
      collection: 'project'
    }
  },
  methods: {
    dismiss_tune() {
      this.$firestoreRefs.item.update({updated: new Date(), dismiss_tune: true})
    }
  }
}
</script>

<style>

</style>
